(function () {
  'use strict';

  var root = document.getElementById('hair-quiz');
  if (!root) return;

  var configUrl = root.getAttribute('data-config-url');
  var stageEl = document.getElementById('hair-quiz-stage');
  var progressBarEl = document.getElementById('hair-quiz-progress-bar');
  var progressWrapEl = document.getElementById('hair-quiz-progress');

  var config = null;
  var answers = {}; 
  var stepIndex = 0; 
  var lastResults = []; 
  var imageCache = {}; 
  var pendingImages = {}; 
  var availability = {}; 
  var variantCache = {}; 
  var pendingVariants = {}; 
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  fetch(configUrl)
    .then(function (res) {
      if (!res.ok) throw new Error('Could not load quiz config');
      return res.json();
    })
    .then(function (data) {
      config = data;
      renderStep();
      config.products.forEach(function (p) { loadProductImage(p); });
    })
    .catch(function (err) {
      console.error('Hair quiz: failed to load hair-quiz-config.json', err);
      stageEl.innerHTML = '<p class="hair-quiz__error">Sorry, this quiz could not load. Please refresh the page.</p>';
    });

  function totalQuestions() {
    return config.questions.length;
  }

  function currentQuestion() {
    return config.questions[stepIndex - 1];
  }

  function updateProgress() {
    if (stepIndex === 0 || stepIndex > totalQuestions()) {
      progressWrapEl.style.display = 'none';
      return;
    }
    progressWrapEl.style.display = 'block';
    var pct = ((stepIndex - 1) / totalQuestions()) * 100;
    progressBarEl.style.width = pct + '%';
  }

  function renderStep() {
    updateProgress();
    if (stepIndex === 0) {
      renderStart();
    } else if (stepIndex <= totalQuestions()) {
      renderQuestion(currentQuestion());
    } else {
      renderResults();
    }
    if (stepIndex > 0) {
      stageEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function renderStart() {
    stageEl.innerHTML =
      '<div class="hair-quiz__start">' +
      '<p>Answer a few quick questions, and we\'ll recommend the right product routine for your hair type.</p>' +
      '<button type="button" class="hair-quiz__btn hair-quiz__btn--primary" id="hair-quiz-start-btn">Start Quiz</button>' +
      '</div>';
    document.getElementById('hair-quiz-start-btn').addEventListener('click', function () {
      track('quiz_started');
      stepIndex = 1;
      renderStep();
    });
  }

  function renderQuestion(question) {
    var selected = answers[question.id] || [];
    var isMulti = question.type === 'multi';
    var maxSelect = question.maxSelect;

    var optionsHtml = question.options
      .map(function (opt) {
        var isSelected = selected.indexOf(opt.id) !== -1;
        return (
          '<button type="button" class="hair-quiz__option' +
          (isSelected ? ' hair-quiz__option--selected' : '') +
          '" data-option-id="' + opt.id + '">' +
          escapeHtml(opt.label) +
          '</button>'
        );
      })
      .join('');

    var hint = isMulti
      ? (maxSelect ? 'Choose up to ' + maxSelect : 'Choose all that apply')
      : 'Choose one';

    stageEl.innerHTML =
      '<div class="hair-quiz__question">' +
      '<p class="hair-quiz__question-count">Question ' + stepIndex + ' of ' + totalQuestions() + '</p>' +
      '<h2 class="hair-quiz__question-text">' + escapeHtml(question.text) + '</h2>' +
      '<p class="hair-quiz__hint">' + hint + '</p>' +
      '<div class="hair-quiz__options">' + optionsHtml + '</div>' +
      '<div class="hair-quiz__nav">' +
      (stepIndex > 1 ? '<button type="button" class="hair-quiz__btn hair-quiz__btn--secondary" id="hair-quiz-back-btn">Back</button>' : '<span></span>') +
      '<button type="button" class="hair-quiz__btn hair-quiz__btn--primary" id="hair-quiz-next-btn" disabled>Next</button>' +
      '</div>' +
      '</div>';

    var nextBtn = document.getElementById('hair-quiz-next-btn');
    nextBtn.disabled = selected.length === 0;

    stageEl.querySelectorAll('.hair-quiz__option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optId = btn.getAttribute('data-option-id');
        var current = answers[question.id] || [];

        if (!isMulti) {
          current = [optId];
        } else if (current.indexOf(optId) !== -1) {
          current = current.filter(function (id) { return id !== optId; });
        } else {
          if (maxSelect && current.length >= maxSelect) {
            current = current.slice(1); 
          }
          current = current.concat([optId]);
        }

        answers[question.id] = current;
        renderQuestion(question); 
      });
    });

    var backBtn = document.getElementById('hair-quiz-back-btn');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        stepIndex -= 1;
        renderStep();
      });
    }

    nextBtn.addEventListener('click', function () {
      stepIndex += 1;
      renderStep();
    });
  }

  function labelFor(questionId, optionId) {
    var q = config.questions.filter(function (q) { return q.id === questionId; })[0];
    if (!q) return '';
    var opt = q.options.filter(function (o) { return o.id === optionId; })[0];
    return opt ? opt.label : '';
  }

 
  function scoreProducts() {
    var picked = [];
    Object.keys(answers).forEach(function (qid) { picked = picked.concat(answers[qid] || []); });

    return config.products.map(function (p) {
      var rule = config.scoringRules[p.sku] || {};
      var points = 0;
      picked.forEach(function (optId) {
        if (Array.isArray(rule)) { if (rule.indexOf(optId) !== -1) points += 1; }
        else if (rule[optId]) { points += rule[optId]; }
      });
      return Object.assign({}, p, { score: points });
    });
  }

  function isAvailable(p) {
    return availability[p.url] !== false; 
  }

  function buildRoutine() {
    var scored = scoreProducts();

    var collectionTotals = {};
    scored.forEach(function (p) {
      if (!p.collection || p.collection === 'Serums') return;
      collectionTotals[p.collection] = (collectionTotals[p.collection] || 0) + p.score;
    });
    var topCollection = Object.keys(collectionTotals).sort(function (a, b) {
      return collectionTotals[b] - collectionTotals[a];
    })[0];
    if (topCollection && collectionTotals[topCollection] === 0) topCollection = null;

    var steps = config.steps || [];
    var optionalSteps = ['treat', 'scalp'];
    var routine = [];

    steps.forEach(function (step) {
      var candidates = scored
        .filter(function (p) { return p.step === step.id && isAvailable(p); })
        .map(function (p) {
          return Object.assign({}, p, { rank: p.score + (p.collection === topCollection ? 0.5 : 0) });
        })
        .sort(function (a, b) { return b.rank - a.rank; });

      var best = candidates[0];
      if (!best) return;
      if (optionalSteps.indexOf(step.id) !== -1 && best.score < 2) return;
      if (best.score === 0) {
        var fallbackSku = config.defaults && config.defaults[step.id];
        var fallback = candidates.filter(function (p) { return p.sku === fallbackSku; })[0];
        if (fallback) best = fallback;
      }
      routine.push(Object.assign({}, best, { stepLabel: step.label }));
    });

    return { products: routine, collection: topCollection };
  }


  function productHandle(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function sizedImage(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function loadProductImage(product) {
    if (product.image) {
      imageCache[product.url] = product.image;
      return Promise.resolve(product.image);
    }
    if (pendingImages[product.url]) return pendingImages[product.url];
    var handle = productHandle(product.url);
    if (!handle) return Promise.resolve(null);

    pendingImages[product.url] = fetch(shopRoot + 'products/' + handle + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (data && typeof data.available === 'boolean') availability[product.url] = data.available;
        var src = data && (data.featured_image || (data.images && data.images[0]));
        imageCache[product.url] = src ? sizedImage(src, 600) : null;
        return imageCache[product.url];
      })
      .catch(function () {
        imageCache[product.url] = null;
        return null;
      });
    return pendingImages[product.url];
  }

  // First available variant (id and live price) for adding a product to the cart
  function loadVariant(product) {
    if (variantCache[product.url] !== undefined) return Promise.resolve(variantCache[product.url]);
    if (pendingVariants[product.url]) return pendingVariants[product.url];
    var handle = productHandle(product.url);
    if (!handle) return Promise.resolve(null);
    pendingVariants[product.url] = fetch(shopRoot + 'products/' + handle + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var variants = (data && data.variants) || [];
        var v = variants.filter(function (x) { return x.available; })[0] || null;
        variantCache[product.url] = v ? { id: v.id, price: v.price / 100 } : null;
        return variantCache[product.url];
      })
      .catch(function () { return null; });
    return pendingVariants[product.url];
  }

  function fillProductImages() {
    stageEl.querySelectorAll('[data-product-image]').forEach(function (wrap) {
      var url = wrap.getAttribute('data-product-image');
      var product = config.products.filter(function (p) { return p.url === url; })[0];
      if (!product) return;
      loadProductImage(product).then(function (src) {
        if (!src) {
          wrap.classList.add('hair-quiz__product-media--empty');
          return;
        }
        var img = document.createElement('img');
        img.src = src;
        img.alt = product.name;
        img.loading = 'lazy';
        img.className = 'hair-quiz__product-img';
        wrap.innerHTML = '';
        wrap.appendChild(img);
      });
    });
  }

  function renderResults() {
    stageEl.innerHTML = '<p class="hair-quiz__loading">Building your routine…</p>';
    var loads = Promise.all(config.products.map(function (p) { return loadProductImage(p); }));
    var timeout = new Promise(function (resolve) { setTimeout(resolve, 3000); });
    Promise.race([loads, timeout]).then(showResults);
  }

  function showResults() {
    var routine = buildRoutine();
    var toShow = routine.products;
    lastResults = toShow;

    var profileParts = [];
    var structureId = (answers.structure || [])[0];
    var textureId = (answers.texture || [])[0];
    if (structureId) profileParts.push(labelFor('structure', structureId).split(':')[0]);
    if (textureId) profileParts.push(labelFor('texture', textureId).split(':')[0]);

    var profileHtml = profileParts.length
      ? '<p class="hair-quiz__profile">Your hair profile: ' + escapeHtml(profileParts.join(' • ')) + '</p>'
      : '';

    var introHtml =
      '<h2 class="hair-quiz__results-title">Your tgin Routine</h2>' +
      (routine.collection
        ? '<p class="hair-quiz__results-intro">Your best match is our <strong>' + escapeHtml(routine.collection) + ' Collection</strong>. Here’s the routine we recommend, step by step:</p>'
        : '<p class="hair-quiz__results-intro">Based on your answers, here’s the routine we recommend, step by step:</p>');

    var cardsHtml = toShow
      .map(function (p, i) {
        return (
          '<div class="hair-quiz__product-card is-picked">' +
          '<p class="hair-quiz__product-step">Step ' + (i + 1) + ': ' + escapeHtml(p.stepLabel) + '</p>' +
          '<label class="hair-quiz__pick"><input type="checkbox" class="hair-quiz__pick-input" data-index="' + i + '" checked> Add to Cart</label>' +
          '<a class="hair-quiz__product-media" href="' + escapeHtml(p.url) + '" data-product-image="' + escapeHtml(p.url) + '" aria-label="' + escapeHtml(p.name) + '"></a>' +
          '<p class="hair-quiz__product-name">' + escapeHtml(p.name) + '</p>' +
          '<p class="hair-quiz__product-price">$' + escapeHtml(p.price) + '</p>' +
          '<a class="hair-quiz__btn hair-quiz__btn--primary" href="' + escapeHtml(p.url) + '">Shop Now</a>' +
          '</div>'
        );
      })
      .join('');

    var emailHtml =
      '<div class="hair-quiz__email">' +
      '<h3 class="hair-quiz__email-title">Email My Results</h3>' +
      '<p class="hair-quiz__email-text">Get your personalized product picks sent to your inbox so you can come back to them anytime.</p>' +
      '<form class="hair-quiz__email-form" id="hair-quiz-email-form" novalidate>' +
      '<label class="hair-quiz__visually-hidden" for="hair-quiz-email">Email address</label>' +
      '<input class="hair-quiz__email-input" type="email" id="hair-quiz-email" name="email" placeholder="Enter Your Email" autocomplete="email" required>' +
      '<button type="submit" class="hair-quiz__btn hair-quiz__btn--primary" id="hair-quiz-email-btn">SEND RESULTS</button>' +
      '</form>' +
      '<p class="hair-quiz__email-message" id="hair-quiz-email-message" role="status" aria-live="polite"></p>' +
      '</div>';

    stageEl.innerHTML =
      '<div class="hair-quiz__results">' +
      profileHtml +
      introHtml +
      '<div class="hair-quiz__product-grid">' + cardsHtml + '</div>' +
      '<div class="hair-quiz__cart-bar">' +
      '<p class="hair-quiz__cart-summary" id="hair-quiz-cart-summary"></p>' +
      '<div class="hair-quiz__cart-actions">' +
      '<button type="button" class="hair-quiz__btn hair-quiz__btn--primary" id="hair-quiz-add-selected">ADD SELECTED TO CART</button>' +
      '<button type="button" class="hair-quiz__btn hair-quiz__btn--secondary" id="hair-quiz-add-all">ADD ALL TO CART</button>' +
      '</div>' +
      '<p class="hair-quiz__cart-message" id="hair-quiz-cart-message" role="status" aria-live="polite"></p>' +
      '</div>' +
      emailHtml +
      '<button type="button" class="hair-quiz__btn hair-quiz__btn--secondary" id="hair-quiz-restart-btn">Retake Quiz</button>' +
      '</div>';

    fillProductImages();
    setupCartPicks(toShow);

    track('quiz_completed', {
      match: routine.collection || 'none',
      products: toShow.map(function (p) { return p.name; }).join(', '),
      product_count: toShow.length
    });
    saveResultToCart(routine);

    stageEl.querySelectorAll('.hair-quiz__product-card a').forEach(function (link) {
      link.addEventListener('click', function () {
        var card = link.closest('.hair-quiz__product-card');
        var name = card ? card.querySelector('.hair-quiz__product-name').textContent : '';
        var step = card ? card.querySelector('.hair-quiz__product-step').textContent : '';
        track('product_clicked', { product: name, step: step });
      });
    });

    document.getElementById('hair-quiz-email-form').addEventListener('submit', handleEmailSubmit);

    document.getElementById('hair-quiz-restart-btn').addEventListener('click', function () {
      track('quiz_retaken');
      answers = {};
      stepIndex = 0;
      renderStep();
    });
  }

  // Results page: pick products with checkboxes, then add the selected ones (or all) to the cart
  function setupCartPicks(products) {
    var inputs = Array.prototype.slice.call(stageEl.querySelectorAll('.hair-quiz__pick-input'));
    var summaryEl = document.getElementById('hair-quiz-cart-summary');
    var addSelectedBtn = document.getElementById('hair-quiz-add-selected');
    var addAllBtn = document.getElementById('hair-quiz-add-all');
    var msgEl = document.getElementById('hair-quiz-cart-message');
    products.forEach(function (p) { loadVariant(p).then(updateSummary); });

    function priceOf(p) {
      var v = variantCache[p.url];
      return v ? v.price : parseFloat(p.price) || 0;
    }

    function picked() {
      return inputs.filter(function (el) { return el.checked; }).map(function (el) { return products[+el.getAttribute('data-index')]; });
    }

    function updateSummary() {
      var list = picked();
      var total = list.reduce(function (sum, p) { return sum + priceOf(p); }, 0);
      summaryEl.textContent = list.length
        ? list.length + ' of ' + products.length + ' selected \u00b7 $' + total.toFixed(2)
        : 'Select the products you want, or add the whole routine.';
      addSelectedBtn.disabled = list.length === 0;
      inputs.forEach(function (el) { el.closest('.hair-quiz__product-card').classList.toggle('is-picked', el.checked); });
    }

    inputs.forEach(function (el) { el.addEventListener('change', updateSummary); });
    addSelectedBtn.addEventListener('click', function () { addToCart(picked(), addSelectedBtn); });
    addAllBtn.addEventListener('click', function () {
      inputs.forEach(function (el) { el.checked = true; });
      updateSummary();
      addToCart(products.slice(), addAllBtn);
    });
    updateSummary();

    function addToCart(list, btn) {
      if (!list.length) return;
      var label = btn.textContent;
      addSelectedBtn.disabled = true;
      addAllBtn.disabled = true;
      btn.textContent = 'ADDING...';
      msgEl.textContent = '';
      msgEl.classList.remove('hair-quiz__cart-message--error');
      Promise.all(list.map(loadVariant)).then(function (variants) {
        var items = [];
        var skipped = [];
        list.forEach(function (p, i) {
          if (variants[i]) items.push({ id: variants[i].id, quantity: 1, properties: { _source: 'Hair quiz' } });
          else skipped.push(p.name);
        });
        if (!items.length) throw { description: 'Sorry, these products are out of stock right now.' };
        return fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (res) {
          return res.json().then(function (data) { if (!res.ok) throw data; return { count: items.length, skipped: skipped }; });
        });
      }).then(function (result) {
        msgEl.textContent = result.count + (result.count === 1 ? ' product' : ' products') + ' added to your cart.' +
          (result.skipped.length ? ' Out of stock right now: ' + result.skipped.join(', ') + '.' : '');
        track('added_to_cart', { count: result.count, products: list.map(function (p) { return p.name; }).join(', ') });
        if (window.tginTrackAdd) window.tginTrackAdd('quiz', list.map(function (p) { return variantCache[p.url] && variantCache[p.url].id; }).filter(Boolean), Math.round(list.reduce(function (sum, p) { return sum + priceOf(p); }, 0) * 100));
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        setTimeout(function () {
          var icon = Array.prototype.find.call(document.querySelectorAll('[data-js-cart-icon]'), function (el) { return el.offsetParent !== null; });
          if (icon) icon.click();
        }, 450);
      }).catch(function (err) {
        msgEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
        msgEl.classList.add('hair-quiz__cart-message--error');
      }).then(function () {
        btn.textContent = label;
        addAllBtn.disabled = false;
        updateSummary();
      });
    }
  }

  function track(eventName, data) {
    data = data || {};
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', eventName);
        Object.keys(data).forEach(function (k) {
          var v = data[k];
          if (typeof v === 'string' || typeof v === 'number') window.clarity('set', eventName + '_' + k, String(v));
        });
      }
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('tgin_hair_quiz:' + eventName, data);
      }
    } catch (e) {}
  }

  
  function saveResultToCart(routine) {
    try {
      fetch(shopRoot + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            '_hair_quiz': 'completed',
            '_hair_quiz_date': new Date().toISOString().slice(0, 10),
            '_hair_quiz_match': routine.collection || 'none',
            '_hair_quiz_picks': routine.products.map(function (p) { return p.sku; }).join(',')
          }
        })
      }).catch(function () {});
    } catch (e) {}
  }


  function answerSummary() {
    var summary = {};
    config.questions.forEach(function (q) {
      summary[q.text] = (answers[q.id] || []).map(function (id) { return labelFor(q.id, id); });
    });
    return summary;
  }

  function klaviyoCompanyId() {
    var fromAttr = root.getAttribute('data-klaviyo-id');
    if (fromAttr) return fromAttr;
    var scripts = document.querySelectorAll('script[src*="klaviyo.js"]');
    for (var i = 0; i < scripts.length; i++) {
      var m = scripts[i].src.match(/company_id=([A-Za-z0-9]+)/);
      if (m) return m[1];
    }
    return 'QYnSV4';
  }

  
  function sendToKlaviyo(email, eventProps) {
    var body = {
      data: {
        type: 'event',
        attributes: {
          properties: eventProps,
          metric: { data: { type: 'metric', attributes: { name: 'Completed Hair Quiz' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }
      }
    };

    var request = fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(klaviyoCompanyId()), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo responded with ' + res.status);
    });

    var timeout = new Promise(function (_, reject) {
      setTimeout(function () { reject(new Error('Timed out sending to Klaviyo')); }, 10000);
    });

    return Promise.race([request, timeout]);
  }

  function handleEmailSubmit(e) {
    e.preventDefault();
    var input = document.getElementById('hair-quiz-email');
    var btn = document.getElementById('hair-quiz-email-btn');
    var msg = document.getElementById('hair-quiz-email-message');
    var email = (input.value || '').trim();

    msg.className = 'hair-quiz__email-message';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.textContent = 'Please enter a valid email address.';
      msg.classList.add('hair-quiz__email-message--error');
      input.focus();
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Sending…';

    var products = lastResults.map(function (p) {
      return {
        name: p.name,
        step: p.stepLabel || '',
        price: '$' + p.price,
        url: p.url,
        image: imageCache[p.url] || ''
      };
    });

    var eventProps = {
      products: products,
      product_names: products.map(function (p) { return p.name; }),
      hair_profile: answerSummary(),
      quiz_url: window.location.href
    };

    sendToKlaviyo(email, eventProps)
      .then(function () {
        track('email_submitted', { match: (lastResults[0] && lastResults[0].collection) || '' });
        document.getElementById('hair-quiz-email-form').style.display = 'none';
        msg.textContent = 'Thanks! Your results are on their way to ' + email + '.';
        msg.classList.add('hair-quiz__email-message--success');
      })
      .catch(function (err) {
        console.error('Hair quiz: could not send results email', err);
        btn.disabled = false;
        btn.textContent = 'Send My Results';
        msg.textContent = 'Sorry, we couldn’t send your results right now. Please try again in a moment.';
        msg.classList.add('hair-quiz__email-message--error');
      });
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();
